<mat-form-field appearance="outline">
    <mat-icon matPrefix class="icon-va-search"></mat-icon>
    <input matInput autocomplete="false" type="search" placeholder="Search" name="account_name" #value
        (input)="applyFilter($event)">
</mat-form-field>

